module.exports = __webpack_public_path__ + "static/media/vegitables_32.fe742431.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_32.csv
// module id = 616
// module chunks = 0